import React, { useState } from 'react';
import { Icon } from '../icon/icon.tsx';
import { classList } from '../../../utils/string.ts';

export type CheckboxProps = {
  label: string;
  name: string;
  checked: boolean;
  onChange: (checked: boolean, name: string) => void;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label = '',
  name = '',
  checked,
  onChange,
  className = '',
  iconClassName = '',
  labelClassName = ''
}) => {
  const [isChecked, setChecked] = useState(checked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    const name = event.target.name;
    setChecked(value);
    onChange?.(value, name);
  };

  return (
    <label className={classList('flex cursor-pointer items-center', className)}>
      <input
        type="checkbox"
        name={name}
        checked={isChecked}
        onChange={handleChange}
        className="hidden"
      />
      <Icon
        name={`checkbox${isChecked ? '-checked' : ''}`}
        className={classList('text-2xl', iconClassName)}
      />
      <span className={classList('font-medium', labelClassName)}>{label}</span>
    </label>
  );
};
